import { render, staticRenderFns } from "./ResponsivePage.vue?vue&type=template&id=1c9cb056&scoped=true"
import script from "./ResponsivePage.vue?vue&type=script&lang=js"
export * from "./ResponsivePage.vue?vue&type=script&lang=js"
import style0 from "./ResponsivePage.vue?vue&type=style&index=0&id=1c9cb056&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9cb056",
  null
  
)

export default component.exports